
<script>
import { nToWord } from '@/utils/helpers'
import adultIcon from '@/assets/images/icons/man.svg?inline'
import childIcon from '@/assets/images/icons/child.svg?inline'

export default {
  name: 'rex-rounded-tourist',
  components: {
    adultIcon,
    childIcon
  },
  props: {
    label: {
      type: String,
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => ''
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    },
    touristIndex: {
      type: Number,
      default: () => null,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: () => true
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data: () => ({
    room: {
      adults: 1,
      children: 0,
      ages: []
    },
    dropdownIsShown: false
  }),
  computed: {
    value() {
      return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
    }
  },
  created() {
    let storeRoom = {}

    if (this.touristIndex >= 0) {
      storeRoom = { ...this.value[this.touristIndex] }
    } else {
      storeRoom = { ...this.value }
    }

    if (storeRoom.children === 0) {
      storeRoom.ages = []
    }

    this.room = storeRoom
  },
  methods: {
    nToChildren: n => nToWord(n, ['реб.', 'реб.', 'дет.']),
    setAgeOfChildren(age, childNumber) {
      this.room.ages[childNumber] = age
    },
    updChildren(value) {
      const currentChildrenAges = Array.isArray(this.room.ages)
        ? this.room.ages
        : Array(value).fill(null)

      this.room.ages = Array(value).fill(null).map((x, i) => currentChildrenAges[i])
    },
    updValue(value) {
      this.$store.commit(`${this.storeModule}/${this.setterName}`, {
        target: this.target,
        value
      })

      this.$emit('onChange', {
        event: value,
        element: this.$vnode.elm
      })
    },
    showDropdown() {
      this.dropdownIsShown = !this.disabled
    },
    hideDropdown() {
      const room = this.room
      const hasErrors = (room.ages.includes(null) || room.ages.includes(undefined))

      if (hasErrors) {
        this.$buefy.snackbar.open({
          message: '<span>Ошибка валидации</span>Возраст детей обязателен к заполнению.',
          type: 'is-danger',
          position: 'is-top-right',
          actionText: 'ОК',
          duration: 10000
        })
      } else {
        const rooms = this.value
        rooms[this.touristIndex] = this.room

        if (this.touristIndex >= 0) {
          this.updValue(rooms)
        } else {
          this.updValue(this.room)
        }

        this.dropdownIsShown = false
      }
    }
  },
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-rounded-tourist"
  >
    <h3
      v-if="showLabel"
      class="rex-rounded-field--label rex-rounded-field__label"
    >
      {{ label }}
    </h3>
    <div
      class="rex-rounded-tourist__trigger"
      :class="{
        'disabled': disabled,
        'active': dropdownIsShown
      }"
      @click="showDropdown"
    >
      <span>
        {{ room.adults }} взр.,
        {{ room.children }}
        {{ nToChildren(room.children) }}
      </span>
      <b-icon
        icon="chevron-down"
        custom-size="mdi-24px"
        class="rex-rounded-tourist--custom-icon-down"
      />
    </div>
    <div
      v-if="dropdownIsShown"
      class="rex-rounded-tourist--dropdown"
    >
      <div class="rex-rounded-tourist--rooms">
        <div class="rex-rounded-tourist--row">
          <div class="rex-rounded-tourist--column">
            <p class="rex-rounded-tourist--title">
              Взрослых
            </p>
            <div class="rex-rounded-tourist--select-row">
              <div class="rex-rounded-tourist--select-icon">
                <adultIcon />
              </div>
              <b-field class="rex-rounded-tourist--select-wp">
                <b-select
                  v-model="room.adults"
                  class="rex-rounded-tourist--select rex-rounded-tourist--select-counter"
                >
                  <option
                    v-for="i in 6"
                    :key="i"
                    :value="i"
                  >
                    {{ i }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
          <div class="rex-rounded-tourist--column">
            <p class="rex-rounded-tourist--title">
              Детей
            </p>
            <div class="rex-rounded-tourist--select-row">
              <div class="rex-rounded-tourist--select-icon">
                <childIcon />
              </div>
              <b-field class="rex-rounded-tourist--select-wp">
                <b-select
                  v-model="room.children"
                  class="rex-rounded-tourist--select rex-rounded-tourist--select-counter"
                  @input="updChildren($event)"
                >
                  <option
                    v-for="i in 5"
                    :key="i"
                    :value="i - 1"
                  >
                    {{ i - 1 }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
        <div
          v-if="room.children"
          class="rex-rounded-tourist--age-of-children"
        >
          <p class="rex-rounded-tourist--title">
            Возраст детей на дату возвращения
          </p>
          <div class="rex-rounded-tourist--row">
            <div
              v-for="child in room.children"
              :key="`${room}_${child}`"
              class="rex-rounded-tourist--column rex-rounded-tourist--column-child"
            >
              <b-field>
                <b-select
                  :value="room.ages[child - 1]"
                  class="rex-rounded-tourist--select rex-rounded-tourist--select-age"
                  @input="setAgeOfChildren($event, child - 1)"
                >
                  <option
                    :value="1"
                  >
                    &lt; 2
                  </option>
                  <option
                    v-for="n in 11"
                    :key="`${child}_${n}`"
                    :value="n + 1"
                  >
                    {{ n + 1 }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="dropdownIsShown"
      class="rex-rounded-tourist--overlay"
      @click="hideDropdown"
    />
  </div>
</template>
